import { ObjectHelpers } from "../../helpers/object-helpers";
import { IndicatorType } from "../enum/indicator-type.enum";

export class IndicatorOptionModel {
    public text = '';
    public chartAreaName = '';
    public name = '';
    public value = IndicatorType.Volume;
    public highChartIndicator = false;
    public defaultValueOne: number | null = null;
    public defaultValueTwo: number | null = null;

    constructor(data: any) {
        this.cast(data);
        if (this.highChartIndicator) {
            this.name = 'highchart-' + this.text;
        }
    }

    public getClassName(): string {
        if (this.highChartIndicator) {
            return this.text.split(' ').join('').replace(/[^\w\s]/gi, '').toLowerCase();
        }
        
        return this.name.split(' ').join('').replace(/[^\w\s]/gi, '').toLowerCase();
    }

    private cast(data: any) {
        ObjectHelpers.setProperties(data, this, true);
    }
}
